import { createActionGroup, props } from "@ngrx/store";

export const ToggleFeatureActions = createActionGroup({
  source: "[Toggle Feature]",
  events: {  
    'update all items': props<{checked: boolean}>(),   
    'update Development Items': props<{checked: boolean}>(),   
  },
});

